import { Button } from '@kcftech/design-system';
import styled, { css } from 'styled-components';

/**
 * Rounded DSM Button
 * TODO: Decide what is primary, secondary, tertiary
 */
export const StyledButton = styled(Button)<{
    $padding?: string;
    $color?: string;
    $background?: string;
    $hoverBackground?: string;
}>`
    white-space: nowrap;
    display: flex !important;
    justify-content: center !important;
    border-radius: 5px !important;
    padding: ${({ $padding }) => ($padding ? `${$padding} !important` : undefined)};
    color: ${({ $color }) => ($color ? `${$color} !important` : undefined)};
    background: ${({ $background }) =>
        $background ? `${$background} !important` : undefined};

    /* Ensure SVG icons follow button's color and don't have separate hover */
    & svg {
        color: inherit;
        fill: currentColor;
        transition: none;
    }

    &:disabled {
        color: var(--action-disabled) !important;
        background: var(--action-disabled-background) !important;
    }

    ${({ $hoverBackground }) =>
        $hoverBackground
            ? css`
                  &:hover:not(:disabled) {
                      background: ${$hoverBackground} !important;
                  }
              `
            : undefined};
`;
